import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { ButtonType, SampleDetailsDto } from '@src/types/types';
import { Button } from '@components/atoms/Button';
import { classNames } from '@utils/classNames';
import { Icon } from '@components/atoms/Icon';
import { IconType } from '@src/types/IconType';
import { Paths } from '@src/routes/paths';

interface UserInfoActionsProps {
  isExpanded: boolean;
  sample: SampleDetailsDto;
}

export const UserInfoActions: React.FC<UserInfoActionsProps> = ({
  isExpanded,
  sample,
}) => {
  const { t } = useTranslation('component', { keyPrefix: 'sampleDetails' });

  return (
    <div className="flex flex-col items-center justify-start space-y-2">
      <Link
        to={`${Paths.SAMPLE_COMMENT}/${sample?.id}?previousPath=${Paths.RESULT}/${sample?.id}`}
        onClick={(e) => e.stopPropagation()}
      >
        <Button
          buttonType={ButtonType.SECONDARY}
          label={t('edit')}
          className="w-fit px-5 print:hidden"
          size="small"
        />
      </Link>
      <div className="flex items-center h-5 pt-1 print:hidden">
        <Icon
          type={IconType.ChevronDownThick}
          className={classNames(
            'h-5 w-5 text-grey1 transition-transform',
            isExpanded ? 'rotate-180' : '',
          )}
        />
      </div>
    </div>
  );
};
